import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { CircularProgress, makeStyles, Fab, Tooltip } from "@material-ui/core";
import { Delete, Edit, Build, Add, DeleteOutline } from "@material-ui/icons";

import DataTable from "../../../datatable";
import useRouter from "../../hook/useRouter";
import Page from "../../common/Page";
import { SelectColumnsButton } from "@cargotic/webapp-component";

const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    display: "flex",
    flexDirection: "column",

    "& > :not(:first-child)": {
      marginTop: spacing(4)
    }
  },
  content: {
    flex: 1
  },
  danger: {
    background: palette.status.danger,
    color: "white",
    "&:hover": {
      background: palette.status.danger
    }
  }
}));

const SettingsRoleOverview = ({
  className,
  tariff,
  isLoading,
  onBreadcrumbsChange,
  userRoleTableProps,

  hasCreateRolePermission,
  hasUpdateRolePermission,
  hasReadRolePermission,
  hasDeleteRolePermission,

  handleDeleteRolesClick
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { history } = useRouter();

  const [isOpenSelectColumnsDialog, setIsOpenSelectColumnsDialog] = useState(false);

  const userRoleHeader = [
    {
      name: "title",
      label: "webapp:common.title.title",
      isOrderable: true
    },
    {
      name: "description",
      label: "webapp:common.title.description",
      isOrderable: false
    }
  ];

  const tableActions = [
    {
      column: [
        {
          handleClick: (id) => history.push(`/settings/role/${id}`),
          icon: <Edit />,
          title: "webapp:settings.title.editUserRole",
          disableFor: !hasUpdateRolePermission ? [-1] : undefined
        }
      ]
    },
  ];

  const {
    data,
    dataCount,
    loading,
    ordering,
    direction,
    checkedAll,
    page,
    selectedColumns,
    rowsPerPage,
    reloadData,
    reloadDataFromScratch,
    handleSort,
    handleSelect,
    handleSelectAll,
    handleChangePage,
    handleChangeRowsPerPage,
    handleChangeSelectedColumns
  } = userRoleTableProps;

  const selectedItems = data.filter(({ selected }) => selected);

  return (
    <Page
      actions={(
        <>
          <Tooltip title={t("webapp:settings.title.create-user-role")}>
            <span>
              <Fab
                color="primary"
                disabled={isLoading || !hasCreateRolePermission}
                onClick={() => history.push(`/settings/role`)}
              >
                <Add />
              </Fab>
            </span>
          </Tooltip>
          <Fab
            className={classes.danger}
            disabled={isLoading || selectedItems.length === 0 || !hasDeleteRolePermission}
            onClick={handleDeleteRolesClick}
          >
            <DeleteOutline />
          </Fab>
        </>
      )}
      tertiaryActions={(
        <SelectColumnsButton onClick={setIsOpenSelectColumnsDialog} />
      )}>
      <div className={clsx(className, classes.root)}>
        <DataTable
          headers={userRoleHeader}
          actions={tableActions}
          data={data}
          dataCount={dataCount}
          loading={loading}
          ordering={ordering}
          selectedColumns={selectedColumns}
          direction={direction}
          checkedAll={checkedAll}
          page={page}
          rowsPerPage={rowsPerPage}
          onSort={handleSort}
          onSelect={handleSelect}
          onSelectAll={handleSelectAll}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          onChangeSelectedColumns={handleChangeSelectedColumns}
          isOpenSelectColumnsDialog={isOpenSelectColumnsDialog}
          setIsOpenSelectColumnsDialog={setIsOpenSelectColumnsDialog}
        />
      </div>
    </Page>
  );
};

export default SettingsRoleOverview;
